

export default (state = [], action) => {
  if (action.type == "SET_NICHMAT") {
    return [...action.value];
  }
  return state;
};